import adminTable from '@store/adminTable/reducers';

import { user } from '@Modules/User/configs/constants';

export default adminTable(user);
